import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Container, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'slices';
import {
  setActivePriceIndex,
  setPriceModalOpen,
  setShowAllValidatePriceErrors,
} from 'slices/product/form/reducer';

import { Formik, FormikProps } from 'formik';

import { validationSchema } from 'pages/Products/PricesModal/ValidationSchema';
import PricesForm from './PricesForm';
import {
  EditPriceForm,
  // GetAllProductsGroupByItemIdNumberFromAPI,
} from 'types/productTypes';
import { putUpdatePrice } from 'services/productService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PricesModal = ({
  fetchAllProducts,
}: {
  fetchAllProducts: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const formikRef = useRef<FormikProps<EditPriceForm>>(null);

  const productFormState = useSelector((state: RootState) => state.Product);
  const { PriceModal } = productFormState.form;

  const toggleModal = useCallback(
    (index: number | null = null) => {
      dispatch(setPriceModalOpen(!PriceModal.priceModalOpen));
      dispatch(setActivePriceIndex(index));
    },
    [PriceModal.priceModalOpen, dispatch]
  );

  const closeModal = () => toggleModal(null);
  const submitPriceForm = async (values: EditPriceForm) => {
    if (
      !values.store_id ||
      values.store_id === '' ||
      !values.item_id ||
      values.item_id === '' ||
      !values.item_id_number ||
      values.item_id_number === ''
    )
      return;
    try {
      const response = await putUpdatePrice(values);

      if (response) {
        const { message, error_code, data } = response;

        if (message === 'OK' && error_code === 0) {
          closeModal();
          dispatch(setShowAllValidatePriceErrors(false));
          toast.success(data.message, { autoClose: 3000 });
          fetchAllProducts();
        } else {
          closeModal();
          dispatch(setShowAllValidatePriceErrors(false));
          toast.error(message, { autoClose: 3000 });
        }
      } else {
        console.error('No response data returned');
        closeModal();
        dispatch(setShowAllValidatePriceErrors(false));
        toast.error((response as any).message, { autoClose: 3000 });
      }
    } catch (error: any) {
      closeModal();
      dispatch(setShowAllValidatePriceErrors(false));
      toast.error(error, { autoClose: 3000 });
    }
  };

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;

        if (
          firstErrorField !== null &&
          firstErrorField.type === 'hidden' &&
          firstErrorField.name === 'category'
        ) {
          const relatedElement = document.querySelector(
            '#react-select-2-input'
          ) as HTMLInputElement | null;

          if (relatedElement) {
            relatedElement.focus();
          }
        } else {
          if (firstErrorField) firstErrorField.focus();
        }
      }
    }
  }, [formikRef, PriceModal.countSubmit]);

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          <Modal
            isOpen={PriceModal.priceModalOpen}
            toggle={() => {
              closeModal();
              dispatch(setShowAllValidatePriceErrors(false));
            }}
            backdrop={'static'}
            centered
          >
            <ModalHeader
              className="bg-light p-3"
              toggle={() => {
                closeModal();
                dispatch(setShowAllValidatePriceErrors(false));
              }}
            >
              {t('Edit Product Prices')}
            </ModalHeader>
            <ModalBody>
              <Formik<EditPriceForm>
                initialValues={PriceModal.PriceValues}
                validationSchema={validationSchema(t)}
                onSubmit={async (
                  values: EditPriceForm
                  // { resetForm }: FormikHelpers<ProductFormDetailsInterface>
                ) => {
                  // alert('yeah!');
                  // console.log(values);
                  await submitPriceForm(values);
                  // await submitPromotionForm(values);
                  // return false;
                  // await submitProductForm(values);
                }}
                enableReinitialize={true}
                innerRef={formikRef}
              >
                {(formik) => (
                  <form noValidate className="" onSubmit={formik.handleSubmit}>
                    <PricesForm formik={formik} dispatch={dispatch} />
                  </form>
                )}
              </Formik>
            </ModalBody>
          </Modal>
        </Container>
        <ToastContainer closeButton={false} limit={1} />
      </div>
    </React.Fragment>
  );
};
export default PricesModal;
